// extracted by mini-css-extract-plugin
module.exports = {"empty":"activityFeedView_empty__1zObJ"};